import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { IBaseCampaignDto, IThrivePackageEmailDetailDto } from '@Workspace/_generated/interfaces';
import { CartItemService } from '../../../../shared-core/components/card-item/card-item.service';
import { CampaignController } from '@Workspace/_generated/services';
import { AuthService } from '@Workspace/auth';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { Constants, Functions } from '@Workspace/common';
import { CampaignService } from '../../../services/campaign.service';


@Component({
    selector: 'campaign-thrive-package',
    templateUrl: './campaign-thrive-package.component.html',
    styleUrls: ['./campaign-thrive-package.component.scss']



})
export class CampaignThrivePackageComponent {
    constructor(private router: Router, public activatedRoute: ActivatedRoute,
        private cardItemService: CartItemService,
        public campaignController: CampaignController,
        public authService: AuthService,
        private datePipe: DatePipe,
        public messageService: MessageService,
        public campaignService: CampaignService
    ) { }

    budget: any;
    startDate: Date = new Date;
    campaignId: any;
    ngUnsubscribe = new Subject();
    @Input() campaignDto: IBaseCampaignDto;
    thrivePackageEmailDetailDto: IThrivePackageEmailDetailDto = {} as IThrivePackageEmailDetailDto;
    isThriveSelected: boolean = false;
    displayBasic: boolean = false;
    functions = Functions;

    ngOnInit() {
        this.authService.userSettings.email;
        this.cardItemService.data
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
                if (!!data) {
                    this.campaignDto = data;
                }
            });
        this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
            this.campaignId = params.slug;
        });
    }
    sendData() {
        if (!!this.startDate && !!this.budget) {
            this.thrivePackageEmailDetailDto.senderEmail = this.authService.userSettings.email;
            this.thrivePackageEmailDetailDto.senderName = this.authService.userSettings.fullName;
            this.thrivePackageEmailDetailDto.startDate = this.datePipe.transform(new Date(this.startDate), "MM/dd/yyyy");
            this.thrivePackageEmailDetailDto.budget = this.budget;
            this.thrivePackageEmailDetailDto.id = Constants.GuidEmpty;
            this.campaignController.SendEmailThrivePackage(this.thrivePackageEmailDetailDto).subscribe(x => x)
            this.showBasicDialog();
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please populate all necessary fields.' });
        }
    }

    onStartDateChanged(startDate: Date) {
        // if(!!startDate)
        //this.startDate = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
    }

    onClose() {
        this.displayBasic = false;
        this.router.navigate(['mogo']);
    }

    showBasicDialog() {
        this.displayBasic = true;
    }

    //method to navigate to home page
    cancel() {
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Now, you will be redirected to Home Page.' });
        setTimeout(
            () => {
                var gridId = 3; // HMP users
                this.isThriveSelected = true;
                this.campaignService.setGridIdId(gridId);
                this.router.navigate(['mogo']),
                    1000
            }
        );
    }
}